import { GET_ALL_SUBJECTGROUP } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_SUBJECTGROUP:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getAllAdmissionSubjectGroupByFormId.js